import { getLanguageLocale } from "./Helpers";

export const toLocalizedDateString = (date: string, locale: string): string => {
  const dt = new Date(date);
  return dt.toLocaleDateString(getLanguageLocale(locale));
};
